(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/marketplace-competition/route-result/assets/javascripts/highscore/highscore-provider.js') >= 0) return;  svs.modules.push('/components/marketplace-competition/route-result/assets/javascripts/highscore/highscore-provider.js');
"use strict";

const {
  useMemo,
  useState,
  useCallback
} = React;
const {
  HighscoreContext
} = svs.components.marketplaceCompetition.routeResult.highscore;
const {
  HighscoreListType
} = svs.components.marketplaceCompetition.services.constants.highscoreConstants;
const typeToDescription = type => {
  switch (type) {
    case HighscoreListType.Individual:
      return 'deltagare';
    case HighscoreListType.Team:
      return 'lag';
    default:
      return '';
  }
};
const HighscoreProvider = _ref => {
  let {
    children
  } = _ref;
  const [type, setType] = useState(HighscoreListType.Individual);
  const [offset, setOffset] = useState(0);
  const changeType = useCallback(type => {
    setType(type);
    setOffset(0);
  }, []);
  const [searchTerm, setSearchTerm] = useState('');
  const providerValue = useMemo(() => ({
    typeDescription: typeToDescription(type),
    type,
    changeType,
    count: 20,
    setSearchTerm,
    searchTerm,
    setOffset,
    offset
  }), [type, changeType, searchTerm, offset]);
  return React.createElement(HighscoreContext.Provider, {
    value: providerValue
  }, children);
};
setGlobal('svs.components.marketplaceCompetition.routeResult.highscore.HighscoreProvider', HighscoreProvider);

 })(window);